<template>
  <v-layout class="grey lighten-4" column>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <div class="title primary--text">{{ section }}</div>
    </div>

    <v-flex xs12>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-text>
              <div
                v-for="(permission, index) in availablePermissions"
                :key="`permission-${index}`">
                <div v-if="permission.components.length">
                  <div
                    v-for="(component, index) in permission.components"
                    :key="`component-${index}`"
                    class="pl-4">
                    <div class="d-flex justify-space-between">
                      <div>
                        <v-checkbox
                          v-model="permissionsForm[permission.module].components[component.component].visible"
                          :label="component.label"
                          color="primary"
                          hide-details
                          :disabled="!permissionsForm[permission.module].visible"
                          @change="checkComponent({ module: permission.module, component: component.component }, $event)"
                        />
                      </div>
                      <div>
                        <v-btn rounded color="primary" @click="savePermissions">Guardar cambios</v-btn>
                      </div>
                    </div>
                    <v-divider class="mt-3"/>
                    <div v-if="component.actions.length">
                      <div class="pl-4 pt-4">
                        Acciones:
                      </div>
                      <div
                        v-for="(action, index) in component.actions"
                        :key="`action-${index}`"
                        class="pl-4">
                        <v-checkbox
                          v-model="permissionsForm[permission.module].components[component.component].actions[action.action]"
                          :label="action.label"
                          color="primary"
                          :disabled="!permissionsForm[permission.module].components[component.component].visible"
                          hide-details
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
          <!-- <v-row>
            <v-col cols="12">
              <v-card flat tile>
                <v-card-title>
                  <v-row>
                    <v-col>
                      Notificaciones de órdenes de compra
                    </v-col>
                    <v-col class="d-flex justify-end">
                      <v-btn
                        rounded
                        small
                        depressed
                        color="primary"
                        @click="openAddPhoneNumberModal">
                        Agregar número de teléfono
                      </v-btn>

                      <AddPhoneNumber provider :id="provider" ref="addPhoneNumber" @updated="get" />
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text>
                  <div class="subtitle">
                    Agrega tu lista de números telefónicos a los que quieras que le llegen notificaciones por WhatsApp de las actualizaciones de órdenes de comrpra.
                  </div>
                  <v-row>
                    <v-col cols="12">
                      <v-list-item
                        v-for="(phone, index) in phoneList"
                        :key="`phone-${index}`">
                        <v-list-item-icon>
                          <v-icon color="green">mdi-whatsapp</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>{{ phone.code }}{{ phone.number }}</v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-action>
                          <div class="d-flex align-center">
                            <v-btn
                              v-if="phone.status === 'pending'"
                              @click="openVerifyNumberModal(phone)"
                              text>
                              <v-icon
                                left
                                size="small">
                                mdi-alert
                              </v-icon>
                              Verificar teléfono
                            </v-btn>

                            <div v-else class="green--text mr-3">
                              <v-icon color="green">
                                mdi-check
                              </v-icon>
                              Número verificado
                            </div>

                            <v-btn
                              fab
                              x-small
                              depressed
                              @click="openDeleteNumber(phone)"
                              color="red">
                              <v-icon
                                color="white"
                                size="small">
                                mdi-delete
                              </v-icon>
                            </v-btn>
                          </div>
                        </v-list-item-action>
                      </v-list-item>

                      <VerifyNumber ref="verifyNumber" :phone="phoneSelected" @updated="get"/>
                      <DeleteNumber ref="deleteNumber" :phone="phoneSelected" :id="provider" provider @updated="get"/>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row> -->
        </v-col>
      </v-row>
    </v-flex>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

  </v-layout>
</template>

<script>
import countrycodes from '@/lib/countrycodes'
// import AddPhoneNumber from '@/components/modals/AddPhoneNumber'
// import VerifyNumber from '@/components/modals/VerifyNumber'
// import DeleteNumber from '@/components/modals/DeleteNumber'

export default {
  name: 'Providers',
  // components: {
  //   AddPhoneNumber,
  //   VerifyNumber,
  //   DeleteNumber
  // },
  data () {
    return {
      countrycodes,
      section: 'Notificaciones',
      overlay: false,
      showPassword: false,
      phoneList: [],
      phoneSelected: {},
      permissionsForm: {
        notifications: {
          visible: true,
          components: {
            orders: {
              visible: true,
              actions: {
                'sent-or-cancel-pucharse-orders': true
              }
            }
          }
        }
      },
      availablePermissions: [
        {
          module: 'notifications',
          label: 'Notificaciones',
          components: [
            {
              component: 'orders',
              label: 'Ordenes de compra',
              actions: [
                {
                  action: 'sent-or-cancel-pucharse-orders',
                  label: 'Notificar cuando soliciten o cancelen una orden de compra'
                }
              ]
            }
          ]
        }
      ]
    }
  },
  computed: {
    provider () {
      return this.$store.state.currentProvider.data._id
    }
    // notificationPermissions () {
    //   return this.$store.state.login.permissions['settings'].components['purchase-orders-notification-provider'].actions
    // }
  },
  async mounted () {
    await this.get()
  },
  methods: {
    async savePermissions () {
      this.overlay = true
      try {
        const payload = {
          role: this.$store.state.login.role,
          permissions: this.permissionsForm,
          email: this.$store.state.login.user.email
        }
        await this.$api.put(`/v1/providers/${this.provider}/users/${this.$store.state.login.user._id}`, payload)
        this.$toasted.show('Se ha actualizado los datos correctamente', { duration: 3000 })
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    checkModule ({ module }, value) {
      Object.keys(this.permissionsForm[module].components).forEach((key) => {
        this.permissionsForm[module].components[key].visible = value
        this.checkComponent({ module, component: key }, value)
      })
    },
    checkComponent ({ module, component }, value) {
      Object.keys(this.permissionsForm[module].components[component].actions).forEach((key) => {
        this.permissionsForm[module].components[component].actions[key] = value
      })
    },
    openDeleteNumber (phone) {
      this.phoneSelected = phone
      this.$refs.deleteNumber.open()
    },
    openVerifyNumberModal (phone) {
      this.phoneSelected = phone
      this.$refs.verifyNumber.open()
    },
    openAddPhoneNumberModal () {
      this.$refs.addPhoneNumber.open()
    },
    searchCode (item, queryText, itemText) {
      const name = item.name.toLowerCase()
      const searchText = queryText.toLowerCase()
      return name.indexOf(searchText) >= 0
    },
    async get () {
      this.overlay = true
      try {
        const response = await this.$api.get(`/v1/providers/${this.provider}/users/detail`)
        this.permissionsForm = { notifications: response.permissions['notifications'] }
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    }
  }
}
</script>
